<template>
  <div :style="{ backgroundColor: '#F9F2ED' }" class="home">
    <nav class="navbar" style="background: inherit; flex-direction: column" role="navigation" aria-label="main navigation">
      <h1 class="page-header text-funky">{{ info.name }}</h1>
      <div style="display: flex">
        <div style="margin-left: auto; margin-right: auto" class="navbar-item">
          <span v-if="currentGame.status == 'live'" class="tag is-warning">Live</span>
          <vac v-else :end-time="getTime().toDate()">
            <template v-slot:process="{ timeObj }">
              <div style="max-height: 85px" class="columns is-mobile">
                <div class="column">
                  <div class="card countdown-card">{{ timeObj.d }}</div>
                  <span class="countdown-label">D</span>
                </div>
                <div class="column">
                  <div class="card countdown-card">{{ timeObj.h }}</div>
                  <span class="countdown-label">H</span>
                </div>
                <div class="column">
                  <div class="card countdown-card">{{ timeObj.m }}</div>
                  <span class="countdown-label">M</span>
                </div>
                <div class="column">
                  <div class="card countdown-card">{{ timeObj.s }}</div>
                  <span class="countdown-label">S</span>
                </div>
              </div>
            </template>
            <template v-slot:finish>
              <span></span>
            </template>
          </vac>
        </div>
      </div>
    </nav>
    <div style="border: 2px solid white; border-radius: 5px; margin-bottom: 24px; margin-top: 5px">
      <div class="columns is-mobile">
        <div style="padding" class="column">
          {{ getTime().format("MMM Do YY") }}
        </div>
        <div class="column">{{ getTime().format("hh:mm A") }}</div>
      </div>
    </div>
    <Links></Links>
    <b-button
      v-if="info.show_agent"
      expanded
      class="has-text-dark card-header-title"
      style="margin-top: 5px; background: yellow"
      @click="agents_modal = true"
      type="is-info"
      >AGENT LIST</b-button
    >
    <b-field type="is-white" custom-class="has-backround-white" style="margin-top: 20px; color: white">
      <b-input
        style="box-shadow: 0px 31px 15px -3px rgba(0, 0, 0, 0.1)"
        custom-class="has-color-dark"
        type="text"
        v-model.lazy.trim="ticket"
        placeholder="Find your ticket"
      ></b-input>
    </b-field>

    <div class="" v-for="item in searchTicket" :key="item.number" style="margin-top: 15px">
      <header class="card-header">
        <p
          style="padding-top: 5px; padding-bottom: 5px; font-family: monospace; border-top-left-radius: 10px; border-top-right-radius: 10px"
          :style="{ 'background-color': !!item.name ? '#F87474' : '#3AB0FF' }"
          :class="{
            'card-header-title has-text-white': true
          }"
        >
          TICKET: {{ item.number }} {{ item.name }}
        </p>
      </header>
      <div
        :style="{ 'background-color': !!item.name ? '#F87474' : '#3AB0FF' }"
        style="font-size: 15px; padding: 5px; border-bottom-left-radius: 10px; border-bottom-right-radius: 10px"
      >
        <div v-for="row in 3" :key="row" style="margin-bottom: 0px; padding: 0" class="columns is-centered is-gapless is-mobile">
          <div
            v-for="column in 9"
            :key="row + '-' + column"
            style="padding-top: 0.1rem !important; margin: 1px; border-radius: 5%"
            class="column has-background-white text-funky"
          >
            {{ item.card[row + 3 * column - 4] }}
          </div>
        </div>
      </div>
      <hr style="background-color: #cfd2cf; width: 50%" v-if="item.number % 6 == 0" />
      <hr style="background-color: #cfd2cf; width: 20%; margin: 1rem 0" v-else-if="item.number % 3 == 0" />
    </div>
    <b-pagination
      v-show="this.info.show_paginate"
      style="margin: 10px"
      :total="cards.length"
      :range-before="2"
      simple
      :range-after="2"
      :current.sync="current"
      order="is-centered"
      :rounded="true"
      :per-page="per_page"
      :icon-prev="'chevron-left'"
      :icon-next="'chevron-right'"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
    ></b-pagination>

    <footer style="padding-bottom: 10px; background-color: #000" class="footer">
      <div class="has-text-centered has-text-black">
        <strong class="has-text-white text-funky">🔥🔥 {{ info.name }} 🔥🔥</strong>
        <h6 style="font-size: 10px; color:white">All Right Reserved. {{ new Date().getFullYear() }}</h6>
      </div>
    </footer>
    <b-modal :active.sync="agents_modal" has-modal-card trap-focus :destroy-on-hide="false" aria-role="dialog" aria-modal>
      <AgentList></AgentList>
    </b-modal>
  </div>
</template>

<script>
  import moment from "moment";
  import Links from "../components/Links.vue";
  import AgentList from "../components/AgentList";

  // @ is an alias to /src
  import { mapState } from "vuex";

  import firebase from "firebase/app";
  import "firebase/firestore";
  import "firebase/auth";
  export default {
    name: "Home",
    data() {
      return {
        agents_modal: false,
        per_page: 50,
        current: 1,
        ticket: ""
      };
    },
    computed: {
      ...mapState(["cards", "info", "currentGame"]),
      activeCards() {
        return this.cards.slice(this.per_page * (this.current - 1), this.per_page * this.current);
      },
      searchTicket() {
        const items = this.cards.filter((card) => {
          if (card.name) {
            return card.name.toLowerCase().includes(this.ticket.toLowerCase()) || card.number.includes(this.ticket);
          }
          return card.number.includes(this.ticket);
        });
        if (this.info.show_paginate) {
          return items.slice(this.per_page * (this.current - 1), this.per_page * this.current);
        }
        return items;
      }
    },
    methods: {
      getTime() {
        if (this.currentGame) return moment(this.currentGame.schedule.seconds * 1000);
        return moment();
      }
    },
    mounted() {
      // eslint-disable-next-line no-undef
      if (this.info.alert) {
        setTimeout(() => {
          this.$buefy.dialog.alert(this.info.alert);
        }, 4000);
      }
      if (this.info.logo_color) {
        document.querySelectorAll(".page-header").forEach((el) => {
          el.style.color = this.info.logo_color;
        });
      }

      firebase
        .firestore()
        .collection("games")
        .where("status", "==", "live")
        .onSnapshot((next) => {
          if (next.docChanges().length) {
            this.$store.commit("SET_GAME_STATUS", "live");
            this.$router.push("/live");
          }
        });
      console.log("%cDeveloped By justraman.dev", "font-size: 40px; color: black");
      console.log("contact: me@justraman.dev");
    },
    components: {
      Links,
      AgentList
    }
  };
</script>

<style scoped>
  .home {
    padding: 6px;
    padding-top: 0%;
  }

  @media (min-width: 992px) {
    .home {
      width: 500px;
      margin: auto;
    }
  }
  .countdown-card {
    padding: 8px;
    border-radius: 10px;
    width: 40px;
    height: 40px;
    font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
    font-weight: 600;
  }
  .countdown-label {
    font-size: 12px;
  }
  .has-background-danger-dark {
    background-color: hsl(56, 100%, 50%);
  }
  .column:after {
    content: " ";
    display: table;
  }
</style>
